import { render, staticRenderFns } from "./ResultTopic.vue?vue&type=template&id=4b725344&scoped=true&"
import script from "./ResultTopic.vue?vue&type=script&lang=js&"
export * from "./ResultTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b725344",
  null
  
)

export default component.exports